/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Upgrade_To_TeamInputs */



/**
* | output |
* | --- |
* | "Upgrade to Team" |
*
* @param {Plan_Tab_Upgrade_To_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_upgrade_to_team = /** @type {((inputs?: Plan_Tab_Upgrade_To_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Upgrade_To_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf Team upgraden")
	return /** @type {LocalizedString} */ ("Upgrade to Team")
});